import React, { useEffect, useState } from "react";
import {
  Paper,
  Typography,
  Stack,
  TextField,
  Button,
  IconButton,
  Grid,
  Box,
} from "@mui/material";
import { DataGrid, GridToolbar } from "@mui/x-data-grid";
import { Link as LinkRRD, useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import NoDataFound from "../../common/NoDataFound";
import LoadingUI from "../../common/LoadingUI";
import { userListAction } from "../../redux/toolkit/users/list";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import moment from "moment";
import { dateFormatStartFun } from "../../helper/dateConverter";
import SearchIcon from "@mui/icons-material/Search";
import InputBase from "@mui/material/InputBase";
import LabelText from "../../common/LabelText";
import { DatePicker } from "@mui/x-date-pickers";

function List() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [publisher_id, setPublisher_id] = useState();
  const [email, setEmail] = useState("");

  const [pageState, setPageState] = useState({ page: 0, pageSize: 25 });
  const [date, setDate] = useState({
    startDate: null,
    endDate: null,
  });

  const appLists = useSelector((state) => state.userList);
  const { status, data, loading: listLoading, total } = appLists;

  const dateWiseUser = () => {
    dispatch(
      userListAction({
        page: pageState.page,
        limit: pageState.pageSize,
        startDate: dateFormatStartFun(date?.startDate),
        endDate: dateFormatStartFun(date?.endDate),
      })
    );
  };

  useEffect(() => {
    dispatch(
      userListAction({
        page: pageState.page,
        limit: pageState.pageSize,
        startDate: dateFormatStartFun(date?.startDate),
        endDate: dateFormatStartFun(date?.endDate),
        email: undefined,
      })
    );
  }, [dispatch, pageState.page, pageState.pageSize]);

  const searchHandler = () => {
    dispatch(
      userListAction({
        page: pageState.page,
        limit: pageState.pageSize,
        email: email,
      })
    );
  };

  const AppColumns = [
    {
      field: "s_no",
      headerName: "S. No.",
      filterable: false,
      flex: 1,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        const { page, pageSize } = pageState;
        const serialNumber =
          page * pageSize + params?.api?.getRowIndex(params.row._id) + 1;
        return serialNumber;
      },
    },

    {
      field: "_id",
      headerName: "User ID",
      flex: 1,
      minWidth: 300,
      headerClassName: "super-app-theme--header",
    },

    {
      field: "email",
      headerName: "Email-Id",
      flex: 1,
      minWidth: 300,
      headerClassName: "super-app-theme--header",
    },

    {
      field: "Details",
      headerName: "Details",
      flex: 1,
      minWidth: 180,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return (
          <>
            <LinkRRD
              to={`/single-user-transaction?user_id=${params?.row?._id}`}
            >
              <Typography>Get Details</Typography>
            </LinkRRD>
          </>
        );
      },
    },

    {
      field: "created_at",
      headerName: "Registered On",
      flex: 1,
      minWidth: 250,
      headerClassName: "super-app-theme--header",
      renderCell: (params) => {
        return (
          <>
            <p>
              {moment(params?.row?.created_at).format("DD-MM-YYYY hh:mm:ss A")}
            </p>
          </>
        );
      },
    },
  ];

  return (
    <>
     
      <Typography sx={{ my: 1, fontWeight: "bold" }} variant="h6">
        User List
      </Typography>

      <Stack
        direction={{ xs: "column", sm: "row" }}
        spacing={2}
        // justifyContent="space-between"
        alignItems="flex-start"
        sx={{ width: "100%" }}
      >
        {/* Search Section */}
        <Stack sx={{ width: { xs: "100%", sm: "40%" } }} spacing={1}>
          <LabelText text="Search By Emails And UserId" />
          <Paper
            elevation={0}
            component="form"
            sx={{
              border: "1px solid rgba(217, 217, 217, 1)",
              height: 40,
              display: "flex",
              alignItems: "center",
              width: { xs: "100%", sm: 400 },
              backgroundColor: "transparent",
              marginTop: "0px !important",
            }}
          >
            <InputBase
              size="small"
              sx={{ ml: 1, flex: 1 }}
              placeholder="Search Here"
              inputProps={{ "aria-label": "search By Emails, UserId" }}
              onChange={(e) => setEmail(e.target.value)}
            />
            <IconButton
              type="button"
              sx={{ p: "10px" }}
              aria-label="search"
              onClick={searchHandler}
            >
              <SearchIcon />
            </IconButton>
          </Paper>
        </Stack>

        {/* Date Range Section */}
        <Stack
          direction={{ xs: "column", sm: "row" }}
          spacing={2}
          alignItems={{ xs: "stretch", sm: "flex-end" }}
          sx={{ width: { xs: "100%", sm: "60%"  } }}
        >
          <Box sx={{ width: { xs:"100%", sm:"35%" } }}>
            <LabelText text="Start Date" />
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                value={date?.startDate}
                maxDate={moment()}
                onChange={(newValue) =>
                  setDate({ ...date, startDate: newValue })
                }
                renderInput={(params) => (
                  <TextField 
                  size="small" 
                  fullWidth {...params}
                  inputProps={{
                        ...params.inputProps,
                        placeholder: "Start Date", // force it inside inputProps
                      }}
                   />
                )}
              />
            </LocalizationProvider>
          </Box>

          <Box sx={{ width: { xs:"100%", sm:"35%" } }}>
            <LabelText text="End Date" />
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DatePicker
                value={date?.endDate}
                minDate={date?.startDate}
                maxDate={moment()}
                onChange={(newValue) => setDate({ ...date, endDate: newValue })}
                renderInput={(params) => (
                  <TextField size="small" fullWidth {...params}
                  inputProps={{
                        ...params.inputProps,
                        placeholder: "End Date", // force it inside inputProps
                      }}
                   />
                )}
              />
            </LocalizationProvider>
          </Box>

          {date.startDate && date.endDate && (
            <Button
              variant="contained"
              sx={{
                backgroundColor: "#000",
                "&:hover": {
                  backgroundColor: "#000",
                },

                width: { xs: "100%", sm: "20%" },
                mt: { xs: 1, sm: 0 },
              }}
              onClick={dateWiseUser}
            >
              Find Data
            </Button>
          )}
        </Stack>
      </Stack>

      <Paper
        sx={{
          marginTop: 2,
          bgcolor: "#fff",
          "& .super-app-theme--header": {
            background: "rgba(254, 206, 113, 0.16)",
            color: "#000",
            borderBottom: " 1px solid #000",
            fontFamily: "Open Sans",
            fontSize: "13px",
          },
        }}
        elevation={0}
      >
        <DataGrid
          sx={{
            border: " 1px solid #000",
            "& .MuiDataGrid-row:hover": {
              background: "rgba(254, 206, 113, 0.16)",
              cursor: "pointer",
            },
          }}
          getRowHeight={({ densityFactor }) => {
            return 70 * densityFactor;
          }}
          autoHeight
          rows={data || []}
          columns={AppColumns}
          getRowId={(row) => row._id}
          disableSelectionOnClick
          experimentalFeatures={{ newEditingApi: true }}
          // pagination
          rowsPerPageOptions={[5, 25, 50, 75, 100]}
          disableColumnSelector
          loading={listLoading ? <LoadingUI /> : false}
          onCellClick={(params) => {
            setPublisher_id(params?.row?._id);
          }}
          components={{
            NoRowsOverlay: () => <NoDataFound />,
            // Toolbar: GridToolbar,
          }}
          rowCount={total}
          paginationModel={setPageState}
          page={pageState.page}
          pageSize={pageState.pageSize}
          paginationMode="server"
          onPageChange={(newPage) => {
            setPageState((old) => ({ ...old, page: newPage }));
          }}
          onPageSizeChange={(newPageSize) =>
            setPageState((old) => ({ ...old, pageSize: newPageSize }))
          }
        />
      </Paper>
    </>
  );
}

export default List;
